exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.svg-icon[data-v-c8a70580] {\r\n  width: 1em;\r\n  height: 1em;\r\n  vertical-align: -0.15em;\r\n  fill: currentColor;\r\n  overflow: hidden;\n}\n.svg-external-icon[data-v-c8a70580] {\r\n  background-color: currentColor;\r\n  -webkit-mask-size: cover !important;\r\n          mask-size: cover !important;\r\n  display: inline-block;\n}\r\n", ""]);

// exports
